{
  "title": "Inflict Wounds",
  "source": "Player's Handbook",
  "levelAndSchool": "1st-level necromancy",
  "level": 1,
  "castingTime": "1 action",
  "range": "Touch",
  "components": "V, S",
  "duration": "Instantaneous",
  "description": [
    "Make a melee spell attack against a creature you can reach. On a hit, the target takes 3d10 necrotic damage.",
    "At Higher Levels. When you cast this spell using a spell slot of 2nd level or higher, the damage increases by 1d10 for each slot level above 1st."
  ],
  "spellLists": ["cleric"]
}
